import { atom } from 'jotai';

import { SimplifiedCameraConfig } from '@core';
import { CameraSetup, CameraSetupResponse } from '@data';

export const cameraConfigAtom = atom<SimplifiedCameraConfig>();
export const cameraSetupAtom = atom<CameraSetupResponse>();
export const cameraSetupMapAtom = atom<Record<number, CameraSetup>>((get) =>
    Object.fromEntries(get(cameraSetupAtom)?.cameras.map((camera) => [camera.view, camera] as const) ?? []),
);

export const cameraViewMapAtom = atom((get) => {
    const cameraSetup = get(cameraSetupAtom);
    return Object.fromEntries(cameraSetup?.cameras.map((camera) => [camera.view, camera] as const) || []);
});

export const comparisonCameraSetupAtom = atom<CameraSetupResponse>();

export const comparisonCameraSetupMapAtom = atom<Record<number, CameraSetup>>((get) =>
    Object.fromEntries(get(comparisonCameraSetupAtom)?.cameras.map((camera) => [camera.view, camera] as const) ?? []),
);

export const comparisonCameraViewMapAtom = atom((get) => {
    const cameraSetup = get(comparisonCameraSetupAtom);
    return Object.fromEntries(cameraSetup?.cameras.map((camera) => [camera.view, camera] as const) || []);
});
